import type { Product } from "@exxatdesignux/product-framework/app-store"

/**
 * Prism Clinical Education suite — shared pink chrome on home and in-app.
 *
 * Exxat One, workspace console, and custom tenant products keep their own
 * theme families; these apps always read `theme-prism` on `<html>`.
 */
export const PRISM_SUITE_PRODUCTS: ReadonlySet<Product> = new Set([
  "exxat-prism",
  "exxat-compliance",
  "exxat-curriculum-mapping",
  "exxat-exam-management",
  "exxat-surveys",
  "exxat-accreditation",
  "exxat-student-success",
])

export function isPrismSuiteProduct(product: Product | null | undefined): boolean {
  return product != null && PRISM_SUITE_PRODUCTS.has(product)
}
